import { DefaultApiFactory } from '@ansvar-sakerhet/api-client';
import { useAuth } from '../hooks/useAuth';
import Axios from 'axios';
import { useAppConfigContext } from '../../config/hooks/useAppConfig';
import { getPublicApiUrl } from '../../config/publicEnv';

export const useApi = () => {
  const { accessToken, logout } = useAuth();
  const { config } = useAppConfigContext();

  const getApi = async () => {
    const axios = Axios.create();
    // Single source of truth: AppConfigContext (build flavor + public API URL).
    // Do not read localStorage here — that caused staging builds to call production.
    const API_URL = getPublicApiUrl() || config.API_URL;

    axios.interceptors.request.use(
      async (requestConfig) => {
        requestConfig.headers.Authorization = accessToken
          ? `Bearer ${accessToken}`
          : undefined;

        return requestConfig;
      },
      (err) => Promise.reject(err)
    );

    axios.interceptors.response.use(
      (response) => response,
      (err) => {
        if (err.response.status === 401) {
          logout();
        }

        return Promise.reject(err);
      }
    );

    const api = DefaultApiFactory(undefined, API_URL, axios);

    return api;
  };

  return getApi;
};
